<mat-card class="mat-elevation-z3 activity-card">
  <table class="w-100">
    <tr>
      <!-- activity status & title -->
      <td>
        <mat-checkbox [checked]="activity.detail.status === 'active'" (change)="onCheckedActivity()" [disabled]="!authorizedToEdit">
          <ng-container *ngIf="activity.reference">
            <span class="font-14">{{ activity.reference.display }}</span>
            <!-- Show the description as a subtitle only if it differs from the main title already displayed above -->
            <span *ngIf="activity.detail.description && activity.detail.description !== activity.reference.display" text color="darklight">
              &nbsp;({{ activity.detail.description }})
            </span>
          </ng-container>
          <ng-container *ngIf="!activity.reference && activity.detail.code">
            <span class="font-14">{{ activity.detail.code.text }}</span>
            <span *ngIf="activity.detail.description && activity.detail.description !== activity.detail.code.text"
              >{{ activity.detail.description }}
            </span>
          </ng-container>
        </mat-checkbox>
      </td>
      <td *ngIf="activity.detail.status === 'active'">
        <!-- product reference / protocol -->
        <div
          *ngIf="
            activity.reference &&
            protocols[activity.reference.reference] &&
            protocols[activity.reference.reference].length &&
            activity.detail?.productReference
          "
        >
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "page.careplan.protocol" | translate }}</mat-label>
            <mat-select
              class="w-100"
              [(ngModel)]="activity.detail.productReference"
              (selectionChange)="onProtocolChanged()"
              name="{{ 'productRef' + activity.reference.reference + '' + activityIndex }}"
              [disabled]="!authorizedToEdit"
              [compareWith]="compareDrugDisplay"
            >
              <mat-option *ngFor="let protocol of protocols[activity.reference.reference]" [value]="protocol">
                {{ protocol.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- route reference / list -->
        <div
          *ngIf="
            activity.reference &&
            routes[activity.reference.reference] &&
            routes[activity.reference.reference].length &&
            activity.detail?.routeReference
          "
        >
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "page.careplan.route" | translate }}</mat-label>
            <mat-select
              class="w-100"
              [(ngModel)]="activity.detail.routeReference"
              (selectionChange)="onRouteChanged()"
              name="{{ 'routeRef' + activity.reference.reference + '' + activityIndex }}"
              [disabled]="!authorizedToEdit"
              [compareWith]="compareReference"
            >
              <mat-option *ngFor="let route of routes[activity.reference.reference]" [value]="route">
                {{ route.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- administration reference / list -->
        <div
          *ngIf="
            activity.reference &&
            administrations[activity.reference.reference] &&
            administrations[activity.reference.reference].length &&
            activity.detail?.administrationReference
          "
        >
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "page.careplan.administration" | translate }}</mat-label>
            <mat-select
              class="w-100"
              [(ngModel)]="activity.detail.administrationReference"
              (selectionChange)="onAdministrationChanged()"
              name="{{ 'administrationRef' + activity.reference.reference + '' + activityIndex }}"
              [disabled]="!authorizedToEdit"
              [compareWith]="compareReference"
            >
              <mat-option *ngFor="let administration of administrations[activity.reference.reference]" [value]="administration">
                {{ administration.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- diluent reference / list -->
        <div
          *ngIf="
            activity.reference &&
            diluents[activity.reference.reference] &&
            diluents[activity.reference.reference].length &&
            activity.detail?.diluentReference
          "
        >
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "page.careplan.diluent" | translate }}</mat-label>
            <mat-select
              class="w-100"
              multiple
              [(ngModel)]="selectedDiluentRefs"
              (selectionChange)="onDiluentChanged()"
              name="{{ 'diluentRef' + activity.reference.reference + '' + activityIndex }}"
              [disabled]="!authorizedToEdit"
              [compareWith]="compareReference"
            >
              <mat-option *ngFor="let diluent of diluents[activity.reference.reference]" [value]="diluent">
                {{ diluent.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-100 font-12" *ngIf="selectedDiluentRefs.length === 1">
            <mat-label>{{ "page.careplan.diluentQuantity" | translate }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="diluentQuantity"
              (ngModelChange)="onDiluentQuantityChanged()"
              name="{{ 'diluentQuantity' + activity.reference.reference + '' + activityIndex }}"
              [disabled]="!authorizedToEdit"
            />
          </mat-form-field>
        </div>
        <!-- administrator reference / list -->
        <div
          *ngIf="
            isActivityADrug() &&
            administrators[activity.reference.reference] &&
            administrators[activity.reference.reference].length &&
            activity.detail?.administratorReference
          "
        >
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "page.careplan.administrator" | translate }}</mat-label>
            <mat-select
              class="w-100"
              [(ngModel)]="activity.detail.administratorReference"
              name="{{ 'administratorRef' + activity.reference.reference + '' + activityIndex }}"
              [disabled]="!authorizedToEdit"
              [compareWith]="compareReference"
            >
              <mat-option *ngFor="let administrator of administrators[activity.reference.reference]" [value]="administrator">
                {{ administrator.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </td>
    </tr>
  </table>

  <!-- drug activity: timing editor, cycle, comment -->
  <div *ngIf="activity.detail.status === 'active' && isActivityADrug()">
    <app-timing-editor
      [mode]="isNewActivityDrug()"
      [authorizedToEdit]="authorizedToEdit"
      [isFrequencyDisplayed]="activity.detail?.productReference?.reference ? true : false"
      [(frequency)]="activity.detail.scheduledTiming.repeat"
      [isMomentRequired]="false"
      [largeDisplay]="true"
      [hasCycle]="drugCycles[activity.reference.reference] ? true : false"
      [hasStepwise]="drugStepwises[activity.reference.reference] ? true : false"
      [careplanStartDate]="createNewCareplan ? careplan.period.start : undefined"
      [careplanEndDate]="createNewCareplan ? careplan.period.end : undefined"
      (useEndDateAsCareplanEndDate)="careplan.period.end = $event"
    >
    </app-timing-editor>
    <app-drug-cycle
      *ngIf="
        activity.detail?.productReference?.reference &&
        (createNewCareplan || activity.detail?.cycle?.cycle?.length > 0 || activity.detail?.stepwise?.stepwises?.length > 0)
      "
      [mode]="isNewActivityDrug()"
      [(drugCycle)]="drugCycles[activity.reference.reference]"
      [(stepwiseDrug)]="drugStepwises[activity.reference.reference]"
      (drugCycleChange)="drugCycleChanged.emit($event)"
      (stepwiseDrugChange)="stepwiseDrugChanged.emit($event)"
    >
    </app-drug-cycle>
    <app-drug-comment
      *ngIf="activity.detail?.productReference?.reference"
      [mode]="isNewActivityDrug()"
      [(drugComment)]="activity.detail.comment"
    >
    </app-drug-comment>
  </div>

  <!-- non-drug activity: date pickers, location, frequency, timing codes, sub-activities -->
  <div *ngIf="activity.detail.status === 'active'">
    <table class="w-100" *ngIf="!isActivityADrug()">
      <tr>
        <td>
          <mat-label class="font-12" item-left>
            {{
              activity.detail.scheduledTiming && activity.detail.scheduledTiming !== undefined
                ? ("schedule.startDate" | translate)
                : ("table.date" | translate)
            }}
            :
          </mat-label>
        </td>
        <td>
          <mat-form-field class="w-100 font-12" *ngIf="activity.detail.scheduledTiming !== undefined">
            <input
              matInput
              (change)="startDateChanged.emit()"
              required
              [(ngModel)]="activity.detail.scheduledTiming.repeat.boundsPeriod.start"
              [matDatepicker]="boundsPeriodStartPicker"
              name="{{ activity.reference.reference }}_boundsPeriodStart"
              [disabled]="!authorizedToEdit"
              [min]="careplan.period.start"
              [max]="
                activity.detail.scheduledTiming.repeat.endless
                  ? noEndDate || !careplan.period.end
                    ? null
                    : careplan.period.end
                  : activity.detail.scheduledTiming.repeat.boundsPeriod.end
              "
              (click)="boundsPeriodStartPicker.open()"
            />
            <mat-datepicker-toggle matSuffix [for]="boundsPeriodStartPicker"> </mat-datepicker-toggle>
            <mat-datepicker #boundsPeriodStartPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="w-100 font-12" *ngIf="activity.detail.scheduledPeriod !== undefined">
            <input
              matInput
              (change)="startDateChanged.emit()"
              required
              [(ngModel)]="activity.detail.scheduledPeriod.start"
              [matDatepicker]="scheduledPeriodStartPicker"
              name="{{ activity.reference.reference }}_scheduledPeriodStart"
              [disabled]="!authorizedToEdit"
              [min]="careplan.period.start"
              [max]="!noEndDate && careplan.period.end ? careplan.period.end : activity.detail.scheduledPeriod.end"
              (click)="scheduledPeriodStartPicker.open()"
            />
            <mat-datepicker-toggle matSuffix [for]="scheduledPeriodStartPicker"> </mat-datepicker-toggle>
            <mat-datepicker #scheduledPeriodStartPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            class="w-100 font-12"
            *ngIf="activity?.detail?.scheduledString !== undefined && !activity.detail.scheduledTiming && activity?.detail?.isDate"
          >
            <input
              matInput
              (change)="startDateChanged.emit()"
              required
              [(ngModel)]="activity.detail.scheduledString"
              [matDatepicker]="scheduledStringPicker"
              name="{{ activity.reference.reference }}_scheduledString"
              [disabled]="!authorizedToEdit"
              [min]="careplan.period.start"
              [max]="noEndDate ? null : careplan.period.end"
              (click)="scheduledStringPicker.open()"
            />
            <mat-datepicker-toggle matSuffix [for]="scheduledStringPicker"> </mat-datepicker-toggle>
            <mat-datepicker #scheduledStringPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            class="w-100 font-12"
            *ngIf="activity?.detail?.scheduledString !== undefined && !activity.detail.scheduledTiming && !activity?.detail?.isDate"
          >
            <input
              matInput
              [ngxMatDatetimePicker]="scheduledStringDatetimePicker"
              required
              (change)="startDateChanged.emit()"
              [disabled]="!authorizedToEdit"
              [(ngModel)]="activity.detail.scheduledString"
              name="{{ activity.reference.reference }}_scheduledString"
              [min]="careplan.period.start"
              [max]="noEndDate ? null : careplan.period.end"
              (click)="scheduledStringDatetimePicker.open()"
            />
            <mat-datepicker-toggle matSuffix [for]="scheduledStringDatetimePicker"> </mat-datepicker-toggle>
            <ngx-mat-datetime-picker
              #scheduledStringDatetimePicker
              [showSpinners]="true"
              [showSeconds]="false"
              [stepHour]="1"
              [stepMinute]="1"
              color="primary"
            >
            </ngx-mat-datetime-picker>
          </mat-form-field>
        </td>
        <td>
          <!-- activity end date toggle -->
          <mat-slide-toggle
            class="font-12"
            *ngIf="activity.detail.scheduledTiming !== undefined"
            [(ngModel)]="activity.detail.scheduledTiming.repeat.endless"
            (change)="onEndlessActivity()"
            name="{{ activity.reference.reference }}_repeatEndless"
            required
            [disabled]="!authorizedToEdit"
          >
            {{ (activity.detail.scheduledTiming.repeat.endless ? "schedule.noEndDate" : "schedule.dateTo") | translate }}
          </mat-slide-toggle>
          <mat-label class="font-12" item-left *ngIf="activity.detail.scheduledPeriod !== undefined">
            {{ "schedule.dateTo" | translate }} :
          </mat-label>
        </td>
        <td>
          <mat-form-field
            class="w-100 font-12"
            [class.mat-form-field-invalid]="isActivityEndDateAfterCareplanEnd()"
            *ngIf="activity.detail.scheduledTiming !== undefined && !activity.detail.scheduledTiming.repeat.endless"
          >
            <input
              matInput
              (change)="endDateChanged.emit()"
              required
              [(ngModel)]="activity.detail.scheduledTiming.repeat.boundsPeriod.end"
              [matDatepicker]="repeatBoundsPeriodEndPicker"
              name="{{ activity.reference.reference }}_repeatBoundsEnd"
              [disabled]="!authorizedToEdit"
              [min]="careplan.period.start ? careplan.period.start : activity.detail.scheduledTiming.repeat.boundsPeriod.start"
              (click)="repeatBoundsPeriodEndPicker.open()"
            />
            <mat-datepicker-toggle matSuffix [for]="repeatBoundsPeriodEndPicker"> </mat-datepicker-toggle>
            <mat-datepicker #repeatBoundsPeriodEndPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            class="w-100 font-12"
            [class.mat-form-field-invalid]="isActivityEndDateAfterCareplanEnd()"
            *ngIf="activity.detail.scheduledPeriod !== undefined"
          >
            <input
              matInput
              (change)="endDateChanged.emit()"
              required
              [(ngModel)]="activity.detail.scheduledPeriod.end"
              [matDatepicker]="scheduledPeriodEndPicker"
              name="{{ activity.reference.reference }}_scheduledEnd"
              [disabled]="!authorizedToEdit"
              [min]="careplan.period.start ? careplan.period.start : activity.detail.scheduledPeriod.start"
              (click)="scheduledPeriodEndPicker.open()"
            />
            <mat-datepicker-toggle matSuffix [for]="scheduledPeriodEndPicker"> </mat-datepicker-toggle>
            <mat-datepicker #scheduledPeriodEndPicker></mat-datepicker>
          </mat-form-field>
          <button
            *ngIf="isActivityEndDateAfterCareplanEnd()"
            mat-button
            color="primary"
            type="button"
            class="font-12"
            style="text-wrap: auto"
            (click)="useActivityEndDateForCareplan()"
          >
            {{ "careplan.useForCareplanEndDate" | translate }}
          </button>
        </td>
      </tr>
    </table>

    <!-- location & performer (one-shot activities) -->
    <table class="w-100" *ngIf="!isActivityADrug()">
      <tr *ngIf="activity.detail.scheduledString !== undefined && !activity.detail.scheduledTiming">
        <td *ngIf="activity.detail?.location?.address">
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "common.location" | translate }}</mat-label>
            <input
              matInput
              class="dateIonInput"
              type="text"
              name="{{ activity.reference.reference }}_address"
              [(ngModel)]="$any(activity.detail.location).address.text"
              [disabled]="!authorizedToEdit"
            />
          </mat-form-field>
        </td>
        <td *ngIf="activity.detail?.performer">
          <mat-form-field class="w-100 font-12" *ngIf="activity.detail.performer.length">
            <mat-label>{{ "common.contact" | translate }}</mat-label>
            <input
              matInput
              class="dateIonInput"
              type="text"
              name="{{ activity.reference.reference }}_performer"
              [(ngModel)]="activity.detail.performer[0].display"
              [disabled]="!authorizedToEdit"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr *ngIf="activity.detail.scheduledString !== undefined && !activity.detail.scheduledTiming && activity.detail?.location?.telecom">
        <td>
          <mat-form-field class="w-100 font-12">
            <mat-label>{{ "model.patient.phone" | translate }}</mat-label>
            <input
              matInput
              class="dateIonInput"
              type="text"
              name="{{ activity.reference.reference }}_telecom"
              [(ngModel)]="$any(activity.detail.location).telecom.value"
              [disabled]="!authorizedToEdit"
            />
          </mat-form-field>
        </td>
        <td></td>
      </tr>
    </table>

    <!-- frequency & period unit -->
    <table class="w-100" *ngIf="!isActivityADrug()">
      <tr *ngIf="activity.detail.scheduledTiming !== undefined">
        <td>
          <mat-form-field class="w-100 font-12">
            <mat-label> {{ "drugagenda.drugfrequency" | translate }}</mat-label>
            <mat-select
              interface="actsheet"
              name="{{ activity.reference.reference }}_repeatFreq"
              [(ngModel)]="activity.detail.scheduledTiming.repeat.frequency"
              [disabled]="!authorizedToEdit"
            >
              <mat-option *ngFor="let time of [1, 2, 3, 4, 5]" [value]="time">{{ time }}X </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="w-100 font-12">
            <mat-label>
              {{
                (activity.detail.scheduledTiming.repeat.periodUnits === "wk" || activity.detail.scheduledTiming.repeat.periodUnits === "h"
                  ? "schedule.every2"
                  : "schedule.every"
                ) | translate
              }}
            </mat-label>
            <mat-select
              [(ngModel)]="activity.detail.scheduledTiming.repeat.period"
              name="{{ activity.reference.reference }}_repeatPeriod"
              (selectionChange)="detectChanges()"
              [disabled]="!authorizedToEdit"
            >
              <mat-option *ngFor="let time of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" [value]="time"> {{ time }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="w-100 font-12">
            <mat-select
              class="w-100"
              name="{{ activity.reference.reference }}_repeatPeriodUnits"
              [(ngModel)]="activity.detail.scheduledTiming.repeat.periodUnits"
              [disabled]="!authorizedToEdit"
              [compareWith]="comparePeriodUnitsFn"
            >
              <mat-option value="h">
                {{ (activity.detail.scheduledTiming.repeat.period > 1 ? "periodUnit.hour.plural" : "periodUnit.hour.long") | translate }}
              </mat-option>
              <mat-option value="d">
                {{ (activity.detail.scheduledTiming.repeat.period > 1 ? "periodUnit.day.plural" : "periodUnit.day.long") | translate }}
              </mat-option>
              <mat-option value="w">
                {{ (activity.detail.scheduledTiming.repeat.period > 1 ? "periodUnit.week.plural" : "periodUnit.week.long") | translate }}
              </mat-option>
              <mat-option value="M">
                {{ (activity.detail.scheduledTiming.repeat.period > 1 ? "periodUnit.month.plural" : "periodUnit.month.long") | translate }}
              </mat-option>
              <mat-option value="y">
                {{ (activity.detail.scheduledTiming.repeat.period > 1 ? "periodUnit.year.plural" : "periodUnit.year.long") | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
    </table>

    <!-- timing codes & quantities -->
    <table
      class="w-100 pb-15"
      *ngIf="activity.detail.scheduledTiming && activity.detail.scheduledTiming.repeat.quantities && !isActivityADrug()"
    >
      <tr>
        <td *ngFor="let timing of timingCodes">
          <mat-checkbox
            [checked]="activity.detail.scheduledTiming.repeat.quantities[timing] !== null"
            (change)="onCheckedTiming($event, timing)"
            [disabled]="!authorizedToEdit"
          >
            {{ "careplan.timingCodes." + timing | translate }}
          </mat-checkbox>
          <br />
          <mat-form-field class="font-12 w-50" *ngIf="isTimingChecked(activity.detail.scheduledTiming.repeat.timingCode, timing)">
            <mat-label>{{ "careplan.quantities" | translate }}</mat-label>
            <mat-select
              (selectionChange)="detectChanges()"
              [disabled]="!authorizedToEdit"
              [(value)]="activity.detail.scheduledTiming.repeat.quantities[timing]"
            >
              <mat-option *ngFor="let quantity of quantities" [value]="quantity">
                {{ quantity }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
    </table>

    <!-- sub-activities (pre/post actions) -->
    <ng-container *ngIf="activity.actionResulting?.length > 0 && displayActionResulting(activity.actionResulting)">
      <hr />
      <mat-label padding class="fontLarger" color="secondary">{{ "careplan.prePostActTitle" | translate }}</mat-label>
      <table class="w-100 actionResultingTable">
        <tr *ngFor="let action of activity.actionResulting; let iAction = index">
          <td *ngIf="!action.notDisplay" style="vertical-align: middle; width: 10%; text-align: center">
            <p>{{ "knowledgebase.knowledgeCriteria.show" | translate }}</p>
          </td>
          <td *ngIf="!action.notDisplay">
            <mat-form-field class="w-100 font-12">
              <mat-icon
                matPrefix
                (click)="action.status = action.status === 'active' ? 'inactive' : 'active'"
                class="fa"
                [ngClass]="{
                  ' fa-calendar-check': action.status === 'active',
                  ' fa-calendar': action.status === 'inactive'
                }"
              >
              </mat-icon>
              <input
                matInput
                type="number"
                pattern="[0-9-]*"
                min="-366"
                max="366"
                [(ngModel)]="action.when.period"
                (change)="periodChange(iAction)"
                name="{{ activity.reference.reference }}_whenPeriod_{{ activityIndex }}_{{ iAction }}"
                [disabled]="!authorizedToEdit"
              />
            </mat-form-field>
          </td>
          <td *ngIf="!action.notDisplay">
            <mat-form-field class="w-100 font-12">
              <mat-select [(value)]="action.when.periodUnits" [disabled]="!authorizedToEdit" [compareWith]="comparePeriodUnitsFn">
                <mat-option *ngFor="let unit of availablePeriodUnits" [value]="unit.value">
                  {{ unit.key }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td *ngIf="!action.notDisplay" style="vertical-align: middle; width: 10%">
            <p>{{ "careplan.after" | translate }}</p>
          </td>
          <td *ngIf="!action.notDisplay">
            <mat-form-field class="w-100 font-12">
              <mat-select [value]="action.detail.target" disabled>
                <mat-option [value]="1">{{ "observation.observation" | translate }} </mat-option>
                <mat-option [value]="2">{{ "page.careplan.questionnaire" | translate }} </mat-option>
                <mat-option [value]="3">{{ "knowledgebase.doccategory.2" | translate }} </mat-option>
                <mat-option [value]="5">{{ "tile.communications" | translate }} </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td *ngIf="!action.notDisplay && action.detail.target !== 5">
            <mat-form-field class="w-100 font-12">
              <mat-select [value]="action.detail.reference.reference" disabled>
                <mat-option [value]="action.detail.reference.reference">{{ action.detail.reference.display }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td *ngIf="!action.notDisplay && action.detail.target === 5" class="showCommunicationLink" (click)="showCommunication(action)">
            {{ "careplan.showCommunication" | translate }}
          </td>
        </tr>
      </table>
    </ng-container>

    <!-- activity note/comment -->
    <mat-form-field class="w-100" *ngIf="activity?.progress?.length">
      <mat-label>{{ "mydrugs.comment" | translate }}</mat-label>
      <textarea
        matInput
        name="comment_{{ activity.progress[0].text }}"
        [(ngModel)]="activity.progress[0].text"
        [disabled]="!authorizedToEdit"
      ></textarea>
    </mat-form-field>
  </div>
</mat-card>
